import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Category } from 'src/app/_models';
import { DocumentService } from 'src/app/_services/document.services';
import { AlertService } from 'src/app/_services/alert.service';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';
import { FormArray, FormControl, FormGroup, Validators, NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-dialog-upload',
  templateUrl: './dialog-upload.component.html',
  styleUrls: ['./dialog-upload.component.scss'],
  providers: [DatePipe]
})
export class DialogUploadComponent implements OnInit {

  @ViewChild('editor') editor: JsonEditorComponent;
  @ViewChild('editorMult') editorMult: JsonEditorComponent;
  @ViewChild('initiateForm') initiateForm: NgForm;

  showData;

  options = new JsonEditorOptions();

  options2 = new JsonEditorOptions();

  @Input() documentDetails: any
  @Output() openUpload = new EventEmitter<boolean>()
  @Output() close = new EventEmitter<boolean>()  
  @Output() refreshDetails = new EventEmitter<boolean>();
  fileToUpload: File = null;
  documentTitle: string = null;
  docId: String = null;
  uploadMessage: Boolean = false;
  toggleUpload: Boolean = true;
  category: Category;
  azureHeader = {};
  uploadResults: Array<JSON> = [];
  properties: any;
  values: any[];
  propertyKeys: String[] = [];
  valuesForm: FormGroup
  multiparts: any[]
  filePath: string = null;
  isError = false;
  errorMessage = '';

  hideFields = ["SF Application ID", "Digitization User Info", "Portal User Info", "Reference Entities", "Source", "Legacy Folder ID", "Batch ID", "ImageTrust Document ID", "Deletion Requested By", "Deletion Requested Date"];
  isAdmin = false;
  adminShowFields = ["Legacy Folder ID"];

  constructor(
    private documentService: DocumentService,
    private alertService: AlertService,
    private datePipe: DatePipe
  ) {

    this.options2.language = 'en';
    this.options.mode = 'code';
    this.options2.mode = 'tree';
    this.options2.modes = this.options.modes = ['form', 'tree', 'view'];
    this.options2.statusBar = this.options.statusBar = false;

    this.options2.onSelectionChange = () => {
      console.log(`onSelectionChange`)
    }
  }


  showJson(d) {
    return JSON.stringify(d, null, 2);
  }

  getData(data, index) {
    this.values[index].value = data;    
  }

  changeLog(event = null) {
    this.showData = this.editor.get();
  }


  ngOnInit(): void {    
    var strArrayAttributes = []
    this.documentDetails.categoryMetaData.properties.forEach(element => {
      this.propertyKeys.push(element.name);
      if (!this.hideFields.includes(element.name)) {
        if (element.data_type == 'str array') {
          strArrayAttributes.push(element.name)
        }
      }
      if (this.hideFields.includes(element.name) && !this.adminShowFields.includes(element.name)) {
        element["isHide"] = true
      } else if (!this.isAdmin && this.adminShowFields.includes(element.name)) {
        element["isHide"] = true
      } else if (this.isAdmin && this.adminShowFields.includes(element.name)) {
        element["isHide"] = false
      } else {
        element["isHide"] = false
      }
    });
    this.values = Object.assign({}, this.documentDetails.metadata.properties)
    this.properties = {}
    this.propertyKeys.forEach(key => {
      if (this.values[String(key)]) {
        this.properties[String(key)] = this.values[String(key)]
      } else {
        this.properties[String(key)] = undefined
      }
      if (this.values[String(key)] == true) {
        this.values[String(key)] = "true";
      }
      if (this.values[String(key)] == false) {
        this.values[String(key)] = "false";
      }
      if (key.includes("Date")) {
        if (this.values[String(key)] != '' && this.values[String(key)] != null) {
          const d = new Date(this.values[String(key)]);
          const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
          let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');        
          this.values[String(key)] = dateString;
        }
      }
    })    
    if (strArrayAttributes.length > 0) {
      this.createValuesForm(strArrayAttributes)
    }    
  }

  createValuesForm(arrayProperties) {
    var formControlObject = {}
    arrayProperties.forEach(property => {
      formControlObject[property] = new FormArray([this.initValues()])
    });
    this.valuesForm = new FormGroup(
      formControlObject
    )
    this.setValuesHandler(arrayProperties)
  }

  setValuesHandler(arrayProperties) {
    var formData = {}
    arrayProperties.forEach(element => {
      this.deleteForm(0, element)
      if (this.values[element]) {
        var values = []
        this.values[element].forEach(arrayValue => {
          this.addNewValue(element)
          values.push({ value: arrayValue })
        });
        formData[element] = values
      }
    });
    this.valuesForm.patchValue(formData)
  }

  initValues() {
    return new FormGroup({
      value: new FormControl('', Validators.required)
    })
  }

  updateList(values, key, event: any) {
    const currentDate = event.target.value;   
    if (key.name == "Key Date") {
      if (currentDate) {
        const d = new Date(currentDate);
        const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
        let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');
        let dateStrFormat = dateString.split("-");
        values['Key Year'] = dateStrFormat[0];
        values['Key Date'] = dateString;
        key['isError'] = false;
        this.initiateForm.controls[key.name].setErrors(null);
      } else {
        key['isError'] = true;
        this.initiateForm.controls[key.name].setErrors({'isError': true});
      }
    }
    if (key.data_type == "date") {
      if (currentDate) {
        const d = new Date(currentDate);
        const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
        let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');        
        values[key.name] = dateString;
        key['isError'] = false;
        this.initiateForm.controls[key.name].setErrors(null);
      } else {
        key['isError'] = true;
        this.initiateForm.controls[key.name].setErrors({'isError': true});
      }
    }
  }

  addNewValue(property) {
    const control = <FormArray>this.valuesForm.get(property);
    control.push(this.initValues());
  }

  getValues(form, property) {
    return form.controls[property].controls;
  }

  deleteForm(index: number, property) {
    this.valuesArray(property).removeAt(index);
  }

  valuesArray(property) {
    return <FormArray>this.valuesForm.get(property)
  }

  validData() {
    return new Promise((resolve, reject) => {
      var isValidData = true;
      if (this.properties["Placeholder UUID"] && this.properties["Placeholder UUID"] != "" && !this.properties["Placeholder UUID"].includes("PLCHD")) {
        isValidData = false;
      }
      resolve(isValidData)
    });
  }

  async uploadDocumentVersion() {
    this.isError = false;
    this.errorMessage = '';
    var systemProperties = null;
    this.documentTitle = this.documentDetails.documentName;
    if (this.fileToUpload) {
      systemProperties = {
        "fileName": this.fileToUpload.name,
        "lastModifiedDate": new Date(this.fileToUpload.lastModified),
        "size": Number(this.fileToUpload.size),
        "type": this.fileToUpload.type
      }
      if (this.fileToUpload.type.includes('pdf') || this.fileToUpload.type.includes('image')) {
        this.filePath = (window.URL || window.webkitURL).createObjectURL(this.fileToUpload)
        console.log("change")
      }
    }

    //build object to be sent to the service
    var uploadReq = {
      "docId": this.documentDetails.documentId,
      "category_id": this.documentDetails.categoryId,
      "meta_data": {},
      "system_properties": systemProperties
    }
    this.documentDetails.categoryMetaData.properties.forEach((obj, index) => {
      if (obj.data_type === "int") {
        this.properties[obj.name] = parseInt(this.values[obj.name]);
      }
      else if (obj.data_type === "date") {
        if (this.values[obj.name] == '' || this.values[obj.name] == null) {
          this.properties[obj.name] = undefined
        } else {
          const editField = new Date(this.values[obj.name]);          
          let dateString = this.datePipe.transform(editField, 'MM/dd/yyyy');          
          this.properties[obj.name] = dateString;
        }
      }
      else if (obj.data_type == "bool") {
        this.properties[obj.name] = false
        if (this.values[obj.name] === "true") {          
          this.properties[obj.name] = true
        }
      }
      else if (obj.data_type === "str") {
        if (this.values[obj.name] == '' || this.values[obj.name] == null) {
          this.properties[obj.name] = undefined
        }
        else {
          this.properties[obj.name] = this.values[obj.name]
        }
      }
      else if (obj.data_type == "object") {
        this.properties[obj.name] = this.showData
      }
      else if (obj.data_type == "str array") {
        var values = []       
        if (!this.hideFields.includes(obj.name)) {
          if (this.valuesForm.value[obj.name].length == 0 || this.valuesForm.value[obj.name] == null) {
            this.properties[obj.name] = []
          }
          else {
            this.valuesForm.value[obj.name].forEach(element => {
              values.push(element.value)
            });
            this.properties[obj.name] = values
          }
        }
      }
      else {
        this.properties[obj.name] = this.values[obj.name];
      }
    });

    let isValid = await this.validData();
    if (!isValid) {
      this.isError = true;
      this.errorMessage = 'Placeholder UUID is invalid, please correct the data';
      return;
    } else {

      uploadReq.meta_data = this.properties;
      console.log("metadata list", this.properties);
      let formData = new FormData();
      formData.append("docId", this.documentDetails.documentId)
      formData.append("category_id", this.documentDetails.categoryId)
      formData.append("meta_data", JSON.stringify(this.properties))
      formData.append("file", this.fileToUpload)
      this.documentService.uploadDocumentVersionDirect(formData).subscribe((resp: any) => {

        // Check if Water Right ID exists and is valid, then update water right reference
        const waterRightId = this.properties['Water Right ID'];
        if (waterRightId && Array.isArray(waterRightId) && waterRightId.length > 0) {
          this.documentService.updateWaterRightReference(resp.docId)
            .subscribe(
              updateResp => {
                console.log('Water Right reference updated successfully for document:', resp.docId);
              },
              updateError => {
                console.error('Failed to update Water Right reference for document:', resp.docId, updateError);
              }
            );
        }
        //reset form
        this.documentTitle = null;
        for (const data of this.documentDetails.categoryMetaData.properties) {
          data.value = null;
        }
        (window.URL || window.webkitURL).revokeObjectURL(this.filePath)
        this.uploadMessage = true;
        this.toggleUpload = false;
      }),
      error =>{
        this.alertService.error(error);
      }
    }
    // console.log("uploadReq :: ", uploadReq)
    // this.documentService.uploadDocumentVersion(uploadReq)
    //   .subscribe(
    //     resp => {
    //       this.docId = resp["docId"];
    //       if (resp['storageProvider'] == "AWS") {
    //         if (resp["uploadUrl"].length > 1) {
    //           console.log("Multipart Upload")
    //           var uploadId = null
    //           var key = null
    //           var start = 0
    //           var end = 0
    //           var part = 1.
    //           const noOfParts = resp["uploadUrl"].length
    //           resp["uploadUrl"].forEach(url => {
    //             if (!uploadId || !key) {
    //               var decodedUrl = decodeURIComponent(url)
    //               var splitData = decodedUrl.split('?')[0]
    //               key = splitData.split("aws.com/")[1]
    //               var params = new URLSearchParams(url);
    //               uploadId = params.toString().split("&")[0].split("=")[1]
    //             }
    //             const chunkSize = (5 * 1024 * 1024)
    //             end = start + chunkSize
    //             if (end > this.fileToUpload.size) {
    //               end = this.fileToUpload.size
    //             }
    //             var chunk = this.fileToUpload.slice(start, start + chunkSize + 1)
    //             start = end
    //             this.multiparts = []
    //             this.documentService.uploadToS3(url, chunk).subscribe(resp => {
    //               this.createMultipartHandler(resp).then(() => {
    //                 part++;
    //                 if ((part - 1) == noOfParts && noOfParts == this.multiparts.length) {
    //                   this.multiparts.sort((a, b) => {
    //                     return a.PartNumber - b.PartNumber;
    //                   });
    //                   const request = {
    //                     uploadId: uploadId,
    //                     key: key,
    //                     parts: this.multiparts
    //                   }
    //                   this.documentService.completeMultipartUpload(request).subscribe(respnse => {
    //                     this.uploadMessage = true;
    //                     this.toggleUpload = false;
    //                     this.refreshDetails.emit(false)
    //                   }
    //                   ,error=>{
    //                     this.documentService.revertUpload(this.docId,resp.version,this.documentDetails.activeVersion).subscribe(response=>{
    //                       // console.log(response)
    //                     })
    //                   })
    //                 }
    //               })
    //             }
    //             ,error=>{
    //               this.documentService.revertUpload(this.docId,resp.version,this.documentDetails.activeVersion).subscribe(response=>{
    //                 // console.log(response)
    //               })
    //             })
    //           })
    //         }
    //         else {
    //           console.log("No Multipart")
    //           this.documentService.uploadFileToS3(resp["uploadUrl"][0], this.fileToUpload)
    //             .subscribe(
    //               resp => {
    //                 this.uploadMessage = true;
    //                 this.toggleUpload = false;
    //                 this.refreshDetails.emit(false)
    //               }, error => {
    //               this.documentService.revertUpload(this.docId,resp.version,this.documentDetails.activeVersion).subscribe(response=>{
    //                 // console.log(response)
    //               })
    //             }
    //             )
    //         }
    //       } else if (resp['storageProvider'] == "Azure") {
    //         this.azureHeader = resp["azureMetadata"];
    //         this.documentService.uploadFileToAzure(resp["uploadUrl"], this.fileToUpload, this.azureHeader)
    //           .subscribe(
    //             resp => {
    //               this.uploadMessage = true;
    //               this.toggleUpload = false;
    //               this.refreshDetails.emit(false)
    //             }
    //           ),
    //           error => {
    //             this.alertService.error(error);
    //           }
    //       } else if (resp['storageProvider'] == "GCP") {
    //         this.documentService.uploadFileToGCP(resp["uploadUrl"], this.fileToUpload)
    //           .subscribe(
    //             resp => {
    //               this.uploadMessage = true;
    //               this.toggleUpload = false;
    //               this.refreshDetails.emit(false)
    //             }
    //           ),
    //           error => {
    //             this.alertService.error(error);
    //           }
    //       }
    //       else {
    //         alert("Invalid Storage Provider! Please try again.")
    //       }
    //     }
    //   ),
    //   error => {
    //     this.alertService.error(error);
    //   }
  }

  createMultipartHandler(response) {
    return new Promise<void>((resolve, reject) => {
      var params = new URLSearchParams(response.url);
      var part = params.get("partNumber")
      var Etag = response.headers.get("ETag")
      var obj = { ETag: Etag, PartNumber: parseInt(part) }
      this.multiparts.push(obj)
      resolve()
    })
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  trackByIndex(index, item) {
    return item.id;
  }

  onClose(): void {
    this.openUpload.emit(false)
  }

  onCancel() {
    this.close.emit(true)
  }

  makeOptions = () => new JsonEditorOptions();

}
